import { P2, P3 } from '../../../styles/FontStyles';
import { Box } from '../../../styles/GlobalComponents';
import { Qualification } from '../CashbackBonusStyled';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Counter } from '../Counter';
import { CashbackBonusInfoModel } from '../CashbackBonus.types';
import { dateDifferenceInDays } from '../../../helpers/helperFunctions';

export const Section3 = ({
  cashback
}: {
  cashback: CashbackBonusInfoModel;
}) => {
  const { t } = useTranslation('cashback');

  const date = new Date(cashback?.limitDate);
  const timestamp = date.getTime();

  const days = dateDifferenceInDays(cashback?.dateFrom, cashback?.limitDate);

  return (
    <Box>
      <Qualification>
        <div>
          <P2 mb='8' bold flex between>
            {t('section3.title', { days })}
          </P2>

          <P3>
            {t('section3.text')}{' '}
            {moment(cashback?.dateFrom).format('DD.MM.YYYY')}
          </P3>
        </div>
        <Counter timestamp={timestamp} />
      </Qualification>
    </Box>
  );
};
